import { render, staticRenderFns } from "./RepublishingDiscoverStats.vue?vue&type=template&id=4f4ca03c&scoped=true&"
import script from "./RepublishingDiscoverStats.vue?vue&type=script&lang=js&"
export * from "./RepublishingDiscoverStats.vue?vue&type=script&lang=js&"
import style0 from "./RepublishingDiscoverStats.vue?vue&type=style&index=0&id=4f4ca03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ca03c",
  null
  
)

export default component.exports